import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { useTrialStatus } from "../../context/TrialStatusContext";
import { useAuth } from "../../context/AuthContext";
import { useTranslation } from "react-i18next";

const ExpiredModal = () => {
  const { accountStatus, isActive, trialDaysRemaining, isExpiredModalOpen, closeExpiredModal } = useTrialStatus();
  const { logout } = useAuth();
  const { t } = useTranslation("portal");

  const isExpired = accountStatus === "EXPIRED" || (isActive === false && (trialDaysRemaining ?? 0) <= 0);
  return (
    <Modal isOpen={Boolean(isExpired && isExpiredModalOpen)} onClose={closeExpiredModal} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("expiredModal.title")}</ModalHeader>
        <ModalCloseButton color="black" _hover={{ color: "black" }} />
        <ModalBody>
          <Text>{t("expiredModal.body")}</Text>
        </ModalBody>
        <ModalFooter>
          <Button
            mr={3}
            onClick={() => {
              closeExpiredModal();
              logout();
            }}
            variant="ghost"
            colorScheme="teal"
            size="sm"
          >
            {t("expiredModal.ok")}
          </Button>
          <Button
            colorScheme="teal"
            size="sm"
            onClick={() =>
              window.open("mailto:contact@asap-app.ai?subject=Reactivate%20subscription", "_blank")
            }
          >
            {t("expiredModal.contactUs")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ExpiredModal;


